__turbopack_context__.v({
  "divider": "page-module-scss-module__j-2ABa__divider",
});
